module.exports = __webpack_public_path__ + "img/home_off.db70d542.svg";